import React, { useEffect, useState } from "react";

import useSocialComments from "./hooks/useSocialComments";
import SocialCommentsShell from "./SocialCommentsShell";

export default function SocialComments() {
	const [channel, setChannel] = useState("all");
	const [status, setStatus] = useState("all");
	const [search, setSearch] = useState("");
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(false);

	const {
		loading,
		error,
		postGroups,
		replyToComment,
		updateCommentStatus,
		loadMoreComments,
		loadingMoreComments,
	} = useSocialComments({ channel, status, search, page, setHasMore });

	useEffect(() => {
		setPage(1);
	}, [channel, status, search]);

	return (
		<SocialCommentsShell
			postGroups={postGroups}
			loading={loading}
			error={error}
			channel={channel}
			status={status}
			search={search}
			onChannelChange={setChannel}
			onStatusChange={setStatus}
			onSearchChange={setSearch}
			onReply={replyToComment}
			onUpdateStatus={updateCommentStatus}
			onLoadMoreComments={loadMoreComments}
			loadingMoreComments={loadingMoreComments}
			setPage={setPage}
			hasMore={hasMore}
		/>
	);
}
